/* Prophecy Hero — interactive range showcase (no dependencies) */
(function () {
  'use strict';
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)');
  var TAU = Math.PI * 2;

  function hexToRgb(h) {
    h = (h || '#0297fc').replace('#', '');
    if (h.length === 3) h = h.replace(/(.)/g, '$1$1');
    var n = parseInt(h, 16);
    return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
  }
  function lerp(a, b, t) { return a + (b - a) * t; }
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function rnd(a, b) { return a + Math.random() * (b - a); }

  function Hero(el) {
    if (el.__ph) return;
    el.__ph = this;
    this.el = el;
    this.bats = [].slice.call(el.querySelectorAll('.ph-bat'));
    this.n = this.bats.length;
    if (!this.n) return;
    this.infos = [].slice.call(el.querySelectorAll('.ph-info'));
    this.names = [].slice.call(el.querySelectorAll('.ph-name'));
    this.tabs = [].slice.call(el.querySelectorAll('.ph-tab'));
    this.stage = el.querySelector('.ph-stage');
    this.canvas = el.querySelector('.ph-canvas');
    this.cursor = el.querySelector('.ph-cursor');
    this.live = el.querySelector('.ph-live');
    this.data = this.bats.map(function (b) {
      return {
        a: b.getAttribute('data-a') || '#0297fc',
        b: b.getAttribute('data-b') || '#0e2399',
        fx: b.getAttribute('data-fx') || 'shards',
        name: b.getAttribute('data-name') || '',
        price: b.getAttribute('data-price') || '',
        url: b.getAttribute('data-url') || '#'
      };
    });
    this.dur = Math.max(3, parseFloat(el.getAttribute('data-autoplay') || '6.5')) * 1000;
    this.autoplay = el.getAttribute('data-autoplay') !== '0' && this.n > 1;
    this.muted = el.getAttribute('data-sound') !== 'true';
    this.pops = (el.getAttribute('data-pops') || 'Middled it|Sweet spot|Ping!').split('|').map(function (s) { return s.trim(); }).filter(Boolean);
    this.i = 0;
    this.lock = 0;
    this.elapsed = 0;
    this.held = 0;
    this.visible = true;
    this.pointer = { x: -9999, y: -9999, on: false, nx: 0, ny: 0, last: 0 };
    this.tilt = { rx: 0, ry: 0, trx: 0, try_: 0, sh: 50, nx: 0, ny: 0 };
    this.waves = [];
    this.parts = [];
    this.bolts = [];
    this.nextBolt = 0;
    this.col = hexToRgb(this.data[0].a);
    this.colT = this.col.slice();
    this.fx = this.data[0].fx;
    this.reduced = RM.matches;
    this.init();
  }

  Hero.prototype.init = function () {
    var self = this, el = this.el;
    el.style.setProperty('--n', this.n);
    this.names.forEach(function (nm) {
      var t = nm.textContent.trim();
      var mask = document.createElement('span');
      mask.className = 'ph-name-mask';
      nm.textContent = '';
      t.split('').forEach(function (ch, k) {
        var s = document.createElement('span');
        s.textContent = ch === ' ' ? '\u00a0' : ch;
        s.style.setProperty('--i', k);
        mask.appendChild(s);
      });
      nm.appendChild(mask);
    });
    this.applyColors(0, true);
    this.bind(0);
    el.classList.toggle('is-autoplay', this.autoplay);
    el.classList.toggle('is-muted', this.muted);
    el.style.setProperty('--ph-dur', this.dur + 'ms');

    // offset so the hero fits beneath the theme header
    this.measure = function () {
      var top = el.getBoundingClientRect().top + window.scrollY;
      el.style.setProperty('--ph-offset', (top < 420 ? top : 0) + 'px');
      self.resize();
    };

    // tabs
    this.tabs.forEach(function (tab, k) {
      tab.addEventListener('click', function () { self.go(k); self.elapsed = 0; });
      tab.addEventListener('keydown', function (e) {
        var m = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
        if (e.key === 'Home') m = -self.i; else if (e.key === 'End') m = self.n - 1 - self.i;
        if (m == null) return;
        e.preventDefault();
        var j = (self.i + m + self.n) % self.n;
        self.go(j); self.tabs[j].focus();
      });
    });
    var pp = el.querySelector('[data-ph-play]');
    if (pp) pp.addEventListener('click', function () {
      self.autoplay = !self.autoplay; self.elapsed = 0;
      el.classList.toggle('is-autoplay', self.autoplay);
      pp.setAttribute('aria-label', self.autoplay ? 'Pause slideshow' : 'Play slideshow');
    });
    var snd = el.querySelector('[data-sound]');
    if (snd) snd.addEventListener('click', function () {
      self.muted = !self.muted; el.classList.toggle('is-muted', self.muted);
      snd.setAttribute('aria-pressed', String(!self.muted));
      if (!self.muted) self.tock(0.6);
    });
    [].slice.call(el.querySelectorAll('[data-ph-prev],[data-ph-next]')).forEach(function (b) {
      b.addEventListener('click', function () { self.step(b.hasAttribute('data-ph-next') ? 1 : -1); self.elapsed = 0; });
    });

    // hold autoplay while reading card / rail
    [].slice.call(el.querySelectorAll('.ph-card,.ph-bottom,.ph-mobile-buy')).forEach(function (z) {
      z.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') self.hold(1); });
      z.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') self.hold(-1); });
    });
    el.addEventListener('focusin', function () { self.focusHeld || (self.focusHeld = true, self.hold(1)); });
    el.addEventListener('focusout', function (e) { if (!el.contains(e.relatedTarget) && self.focusHeld) { self.focusHeld = false; self.hold(-1); } });

    // pointer
    el.addEventListener('pointermove', function (e) { self.onMove(e); }, { passive: true });
    el.addEventListener('pointerleave', function () { self.pointer.on = false; self.showCursor(false); });
    this.stage.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') self.showCursor(true); });
    this.stage.addEventListener('pointerleave', function () { self.showCursor(false); });
    this.stage.addEventListener('pointerdown', function (e) { self.onDown(e); });
    window.addEventListener('pointerup', function (e) { self.onUp(e); });
    this.stage.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); var r = self.stage.getBoundingClientRect(), s = self.el.getBoundingClientRect(); self.hit(r.left - s.left + r.width / 2, r.top - s.top + r.height * .62); }
    });

    window.addEventListener('resize', function () { clearTimeout(self._rz); self._rz = setTimeout(self.measure, 120); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var v = en[0].isIntersecting;
        if (v !== self.visible) { self.visible = v; self.hold(v ? -1 : 1); if (v) self.kick(); }
      }, { threshold: 0.05 }).observe(el);
    }
    document.addEventListener('visibilitychange', function () { if (!document.hidden) self.kick(); });
    RM.addEventListener && RM.addEventListener('change', function () { self.reduced = RM.matches; self.resize(); });

    this.ctx = this.canvas ? this.canvas.getContext('2d') : null;
    this.measure();

    var first = this.bats[0].querySelector('img');
    var ready = function () {
      if (self.readyDone) return; self.readyDone = true;
      requestAnimationFrame(function () {
        el.classList.add('is-ready');
        self.wave(self.w / 2, self.h * .55, 1.1, 0.9);
        setTimeout(function () { el.classList.add('is-settled'); }, 1700);
      });
    };
    if (first && !first.complete) { first.addEventListener('load', ready); first.addEventListener('error', ready); setTimeout(ready, 1500); }
    else ready();

    this.last = performance.now();
    this.kick();
  };

  Hero.prototype.hold = function (d) {
    this.held = Math.max(0, this.held + d);
    this.el.classList.toggle('is-held', this.held > 0);
  };

  Hero.prototype.resize = function () {
    if (!this.canvas) return;
    var r = this.el.getBoundingClientRect();
    this.w = r.width; this.h = r.height;
    var dpr = Math.min(window.devicePixelRatio || 1, this.w < 768 ? 1.5 : 2);
    this.dpr = dpr;
    this.canvas.width = Math.round(this.w * dpr);
    this.canvas.height = Math.round(this.h * dpr);
    var R = this.w < 768 ? 19 : 30;
    this.R = R;
    var hw = Math.sqrt(3) * R, vh = 1.5 * R, cells = [];
    for (var row = -1, y = 0; y < this.h + R * 2; row++, y = row * vh) {
      for (var col = -1; col * hw < this.w + hw; col++) {
        cells.push({ x: col * hw + (row & 1 ? hw / 2 : 0), y: y, e: 0 });
      }
    }
    this.cells = cells;
    var hex = new Path2D();
    for (var k = 0; k < 6; k++) {
      var a = TAU / 6 * k + Math.PI / 6, px = Math.cos(a) * (R - 1.5), py = Math.sin(a) * (R - 1.5);
      k ? hex.lineTo(px, py) : hex.moveTo(px, py);
    }
    hex.closePath();
    this.hex = hex;
    // static base grid
    var base = document.createElement('canvas');
    base.width = this.canvas.width; base.height = this.canvas.height;
    var b = base.getContext('2d');
    b.setTransform(dpr, 0, 0, dpr, 0, 0);
    b.lineWidth = 1;
    for (var c = 0; c < cells.length; c++) {
      var ce = cells[c];
      var fall = 1 - Math.min(1, Math.hypot(ce.x - this.w / 2, (ce.y - this.h * .5) * 1.3) / (Math.max(this.w, this.h) * .75));
      b.strokeStyle = 'rgba(120,160,255,' + (0.025 + fall * 0.07).toFixed(3) + ')';
      b.setTransform(dpr, 0, 0, dpr, ce.x * dpr, ce.y * dpr);
      b.stroke(hex);
    }
    this.base = base;
    if (this.reduced && this.ctx) { this.ctx.setTransform(1, 0, 0, 1, 0, 0); this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height); this.ctx.drawImage(base, 0, 0); }
    this.kick();
  };

  Hero.prototype.onMove = function (e) {
    var r = this.el.getBoundingClientRect();
    var p = this.pointer;
    p.x = e.clientX - r.left; p.y = e.clientY - r.top; p.on = e.pointerType === 'mouse' || this.dragging; p.last = performance.now();
    var s = this.stage.getBoundingClientRect();
    var cx = s.left + s.width / 2 - r.left, cy = s.top + s.height / 2 - r.top;
    if (e.pointerType === 'mouse') {
      this.tilt.nx = clamp((p.x - cx) / (r.width / 2), -1, 1);
      this.tilt.ny = clamp((p.y - cy) / (r.height / 2), -1, 1);
    } else if (this.dragging) {
      this.tilt.nx = clamp((e.clientX - this.dragX) / 140, -1, 1);
      this.tilt.ny = 0;
    }
    if (this.cursor && e.pointerType === 'mouse') {
      this.cursor.style.setProperty('--cx', p.x + 'px');
      this.cursor.style.setProperty('--cy', p.y + 'px');
    }
    this.kick();
  };

  Hero.prototype.showCursor = function (on) {
    if (!this.cursor) return;
    this.cursor.style.setProperty('--co', on ? 1 : 0);
    this.cursor.style.setProperty('--cs', on ? 1 : .2);
  };

  Hero.prototype.onDown = function (e) {
    var r = this.el.getBoundingClientRect();
    if (e.pointerType === 'mouse') {
      if (e.button !== 0) return;
      this.hit(e.clientX - r.left, e.clientY - r.top);
      return;
    }
    this.dragging = true; this.dragX = e.clientX; this.dragY = e.clientY; this.dragT = performance.now();
    this.downPos = { x: e.clientX - r.left, y: e.clientY - r.top };
  };

  Hero.prototype.onUp = function (e) {
    if (!this.dragging) return;
    this.dragging = false;
    var dx = e.clientX - this.dragX, dy = e.clientY - this.dragY;
    this.tilt.nx = 0;
    if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) { this.step(dx < 0 ? 1 : -1); this.elapsed = 0; }
    else if (Math.abs(dx) < 12 && Math.abs(dy) < 12 && performance.now() - this.dragT < 600) this.hit(this.downPos.x, this.downPos.y);
  };

  Hero.prototype.hit = function (x, y) {
    var el = this.el, bat = this.bats[this.i];
    el.classList.add('has-hit');
    this.wave(x, y, 1.25, 1);
    this.burst(x, y, this.reduced ? 0 : 30);
    if (this.fx === 'bolts' && !this.reduced) this.bolt(x, y);
    this.tock(1);
    var s = this.stage.getBoundingClientRect(), r = el.getBoundingClientRect();
    bat.style.setProperty('--hz', (x < s.left - r.left + s.width / 2 ? 3 : -3) + 'deg');
    bat.classList.remove('is-hit'); void bat.offsetWidth; bat.classList.add('is-hit');
    clearTimeout(this._hit); this._hit = setTimeout(function () { bat.classList.remove('is-hit'); }, 600);
    if (this.pops.length) {
      var pop = document.createElement('span');
      pop.className = 'ph-pop'; pop.setAttribute('aria-hidden', 'true');
      pop.textContent = this.pops[Math.floor(Math.random() * this.pops.length)];
      pop.style.left = x + 'px'; pop.style.top = (y - 30) + 'px';
      el.appendChild(pop);
      setTimeout(function () { pop.remove(); }, 1150);
    }
  };

  Hero.prototype.tock = function (vol) {
    if (this.muted) return;
    try {
      var AC = window.AudioContext || window.webkitAudioContext;
      if (!AC) return;
      var ac = this.ac || (this.ac = new AC());
      if (ac.state === 'suspended') ac.resume();
      var t = ac.currentTime, out = ac.createGain();
      out.gain.value = 0.55 * vol; out.connect(ac.destination);
      // leather-on-willow: bright noise click + resonant body
      var len = Math.floor(ac.sampleRate * 0.06), buf = ac.createBuffer(1, len, ac.sampleRate), d = buf.getChannelData(0);
      for (var i = 0; i < len; i++) d[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / len, 4);
      var nz = ac.createBufferSource(); nz.buffer = buf;
      var bp = ac.createBiquadFilter(); bp.type = 'bandpass'; bp.frequency.value = 2400; bp.Q.value = 0.9;
      var ng = ac.createGain(); ng.gain.setValueAtTime(0.9, t); ng.gain.exponentialRampToValueAtTime(0.001, t + 0.06);
      nz.connect(bp); bp.connect(ng); ng.connect(out); nz.start(t);
      [[1180, 820, 0.42, 0.16], [620, 470, 0.3, 0.12], [170, 120, 0.35, 0.09]].forEach(function (p) {
        var o = ac.createOscillator(), g = ac.createGain();
        o.type = 'sine'; o.frequency.setValueAtTime(p[0], t); o.frequency.exponentialRampToValueAtTime(p[1], t + p[3]);
        g.gain.setValueAtTime(0.0001, t); g.gain.exponentialRampToValueAtTime(p[2], t + 0.004); g.gain.exponentialRampToValueAtTime(0.0001, t + p[3]);
        o.connect(g); g.connect(out); o.start(t); o.stop(t + p[3] + 0.02);
      });
    } catch (err) { /* audio optional */ }
  };

  Hero.prototype.step = function (d) { this.go((this.i + d + this.n) % this.n, d); };

  Hero.prototype.go = function (j, dir) {
    if (j === this.i || !this.n) return;
    var now = performance.now();
    if (now < this.lock) return;
    this.lock = now + 650;
    var prev = this.i, self = this;
    if (dir == null) dir = j > prev ? 1 : -1;
    var rev = dir < 0;
    var out = this.bats[prev], inn = this.bats[j];
    [out, inn].forEach(function (b) { b.classList.remove('is-leaving', 'is-entering', 'rev', 'is-hit'); });
    out.classList.remove('is-active');
    if (!this.reduced) { out.classList.add('is-leaving'); inn.classList.add('is-entering'); if (rev) { out.classList.add('rev'); inn.classList.add('rev'); } }
    inn.classList.add('is-active');
    clearTimeout(this._sw);
    this._sw = setTimeout(function () { out.classList.remove('is-leaving', 'rev'); inn.classList.remove('is-entering', 'rev'); }, 1200);
    this.names[prev] && this.names[prev].classList.remove('is-active');
    this.names[j] && this.names[j].classList.add('is-active');
    this.infos[prev] && this.infos[prev].classList.remove('is-active');
    this.infos[j] && this.infos[j].classList.add('is-active');
    this.infos.forEach(function (n, k) { n.setAttribute('aria-hidden', String(k !== j)); });
    this.tabs.forEach(function (t, k) { t.setAttribute('aria-selected', String(k === j)); t.tabIndex = k === j ? 0 : -1; });
    var rail = this.tabs[j] && this.tabs[j].parentNode;
    if (rail && rail.scrollWidth > rail.clientWidth + 4) {
      var tb = this.tabs[j];
      rail.scrollTo({ left: tb.offsetLeft - (rail.clientWidth - tb.offsetWidth) / 2, behavior: this.reduced ? 'auto' : 'smooth' });
    }
    this.i = j;
    this.elapsed = 0;
    this.applyColors(j);
    this.bind(j);
    setTimeout(function () {
      var s = self.stage.getBoundingClientRect(), r = self.el.getBoundingClientRect();
      self.wave(s.left - r.left + s.width / 2, s.top - r.top + s.height * .66, 1, .8);
    }, this.reduced ? 0 : 420);
    if (this.live) this.live.textContent = this.data[j].name + (this.data[j].price ? ', ' + this.data[j].price : '');
    this.kick();
  };

  Hero.prototype.applyColors = function (j) {
    var d = this.data[j];
    this.el.style.setProperty('--ph-a', d.a);
    this.el.style.setProperty('--ph-b', d.b);
    this.colT = hexToRgb(d.a);
    this.fx = d.fx;
    this.nextBolt = performance.now() + 1400;
    this.parts.forEach(function (p) { if (!p.burst) p.fade = true; });
  };

  Hero.prototype.bind = function (j) {
    var d = this.data[j];
    [].slice.call(this.el.querySelectorAll('[data-ph-bind]')).forEach(function (n) {
      var k = n.getAttribute('data-ph-bind');
      if (k === 'url') n.setAttribute('href', d.url);
      else if (d[k] != null) n.textContent = d[k];
    });
  };

  /* ---------- effects ---------- */
  Hero.prototype.wave = function (x, y, strength, speed) {
    if (this.reduced) return;
    this.waves.push({ x: x, y: y, t: performance.now(), s: strength || 1, v: (speed || 1) * 0.9 });
    if (this.waves.length > 6) this.waves.shift();
    this.kick();
  };

  Hero.prototype.burst = function (x, y, n) {
    for (var i = 0; i < n; i++) {
      var a = rnd(0, TAU), sp = rnd(2, 8);
      this.parts.push({ x: x, y: y, vx: Math.cos(a) * sp, vy: Math.sin(a) * sp - 1.5, life: 0, max: rnd(30, 60), size: rnd(1, 2.6), kind: 'spark', burst: true, white: Math.random() < .45 });
    }
  };

  Hero.prototype.bolt = function (tx, ty) {
    var x0 = tx + rnd(-this.w * .25, this.w * .25), pts = [[x0, -10], [tx, ty]];
    for (var it = 0; it < 6; it++) {
      var np = [pts[0]];
      for (var k = 1; k < pts.length; k++) {
        var a = pts[k - 1], b = pts[k], off = Math.hypot(b[0] - a[0], b[1] - a[1]) * .22;
        np.push([(a[0] + b[0]) / 2 + rnd(-off, off), (a[1] + b[1]) / 2 + rnd(-off * .3, off * .3)], b);
      }
      pts = np;
    }
    this.bolts.push({ pts: pts, t: performance.now() });
  };

  Hero.prototype.spawn = function () {
    var w = this.w, h = this.h, k = this.fx, p = { life: 0, kind: k, rot: rnd(0, TAU), vr: rnd(-.03, .03) };
    if (k === 'petals') { p.x = rnd(-w * .1, w); p.y = rnd(-40, -10); p.vx = rnd(.3, .9); p.vy = rnd(.5, 1.1); p.size = rnd(5, 9); p.max = rnd(400, 700); p.ph = rnd(0, TAU); }
    else if (k === 'embers') { p.x = w / 2 + rnd(-w * .32, w * .32); p.y = h + 10; p.vx = rnd(-.3, .3); p.vy = rnd(-1.6, -.6); p.size = rnd(1.2, 3); p.max = rnd(200, 420); p.ph = rnd(0, TAU); }
    else if (k === 'snow') { p.x = rnd(0, w); p.y = rnd(-20, -5); p.vx = rnd(-.15, .15); p.vy = rnd(.25, .7); p.size = rnd(.8, 2); p.max = rnd(700, 1200); p.ph = rnd(0, TAU); }
    else if (k === 'bolts' || k === 'dust') { p.x = rnd(0, w); p.y = rnd(h * .1, h); p.vx = rnd(-.15, .15); p.vy = rnd(-.45, -.1); p.size = rnd(.8, 2.2); p.max = rnd(300, 600); p.ph = rnd(0, TAU); p.kind = 'dust'; }
    else { p.x = rnd(0, w); p.y = h + 10; p.vx = rnd(-.2, .2); p.vy = rnd(-.9, -.3); p.size = rnd(3, 7); p.max = rnd(400, 800); p.kind = 'shards'; }
    this.parts.push(p);
  };

  Hero.prototype.kick = function () {
    if (this.raf || this.reduced) return;
    var self = this;
    this.last = performance.now();
    this.raf = requestAnimationFrame(function loop(t) {
      self.raf = 0;
      if (!self.el.isConnected || !self.visible || document.hidden) return;
      self.frame(t);
      self.raf = requestAnimationFrame(loop);
    });
  };

  Hero.prototype.frame = function (now) {
    var dt = Math.min(64, now - this.last); this.last = now;
    var el = this.el, k60 = dt / 16.67;

    // autoplay
    if (this.autoplay && !this.held) {
      this.elapsed += dt;
      if (this.elapsed >= this.dur) { this.step(1); this.elapsed = 0; }
    }

    // tilt (idle sway when pointer is still)
    var T = this.tilt, idle = now - this.pointer.last > 2500 && !this.dragging;
    var nx = idle ? Math.sin(now / 2400) * .35 : T.nx, ny = idle ? Math.cos(now / 3100) * .2 : T.ny;
    T.ry = lerp(T.ry, nx * 18, .07 * k60);
    T.rx = lerp(T.rx, -ny * 9, .07 * k60);
    T.sh = lerp(T.sh, 50 - nx * 55, .07 * k60);
    el.style.setProperty('--ph-ry', T.ry.toFixed(2) + 'deg');
    el.style.setProperty('--ph-rx', T.rx.toFixed(2) + 'deg');
    el.style.setProperty('--ph-shx', T.sh.toFixed(1) + '%');
    el.style.setProperty('--ph-nx', (-T.ry * 1.4).toFixed(1) + 'px');
    el.style.setProperty('--ph-ny', (T.rx * 1.2).toFixed(1) + 'px');

    // scroll exit
    var r = el.getBoundingClientRect(), p = clamp(-r.top / Math.max(1, r.height), 0, 1);
    el.style.setProperty('--ph-sy', (p * 90).toFixed(1) + 'px');
    el.style.setProperty('--ph-ss', (1 + p * .12).toFixed(3));
    el.style.setProperty('--ph-fade', (1 - p * 1.5).toFixed(3));
    el.style.setProperty('--ph-lift', (-p * 50).toFixed(1) + 'px');

    if (!this.ctx || !this.cells) return;
    var ctx = this.ctx, dpr = this.dpr, w = this.w, h = this.h;
    for (var c = 0; c < 3; c++) this.col[c] = lerp(this.col[c], this.colT[c], .05 * k60);
    var rgb = this.col.map(Math.round).join(',');

    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    ctx.drawImage(this.base, 0, 0);

    // hex energy
    var P = this.pointer, waves = this.waves, sig2 = 2 * 130 * 130;
    for (var wi = waves.length - 1; wi >= 0; wi--) { if (now - waves[wi].t > 2600) waves.splice(wi, 1); }
    var sweep = (now / 7000) % 1, sx = lerp(-w * .3, w * 1.3, sweep);
    var cells = this.cells, hex = this.hex;
    ctx.lineWidth = 1.2;
    for (var i = 0; i < cells.length; i++) {
      var ce = cells[i], e = 0;
      if (P.on) { var dx = ce.x - P.x, dy = ce.y - P.y; e = Math.exp(-(dx * dx + dy * dy) / sig2) * .6; }
      for (var q = 0; q < waves.length; q++) {
        var wv = waves[q], age = (now - wv.t) / 1000, rad = age * 900 * wv.v, d = Math.hypot(ce.x - wv.x, ce.y - wv.y), band = (d - rad) / 46;
        if (band > -3 && band < 3) e += Math.exp(-band * band) * wv.s * Math.max(0, 1 - age / 2.4) * .85;
      }
      var sd = (ce.x + ce.y * .5 - sx) / 120;
      if (sd > -3 && sd < 3) e += Math.exp(-sd * sd) * .07;
      ce.e = Math.max(ce.e * Math.pow(.9, k60), e);
      if (ce.e > .018) {
        var ee = Math.min(1, ce.e);
        ctx.setTransform(dpr, 0, 0, dpr, ce.x * dpr, ce.y * dpr);
        ctx.fillStyle = 'rgba(' + rgb + ',' + (ee * .16).toFixed(3) + ')';
        ctx.fill(hex);
        ctx.strokeStyle = 'rgba(' + rgb + ',' + (ee * .85).toFixed(3) + ')';
        ctx.stroke(hex);
      }
    }

    // particles
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    var target = w < 768 ? 22 : 44, live = 0, parts = this.parts;
    for (var j = 0; j < parts.length; j++) if (!parts[j].burst && !parts[j].fade) live++;
    if (live < target && Math.random() < .5 * k60) this.spawn();
    for (var m = parts.length - 1; m >= 0; m--) {
      var pt = parts[m];
      pt.life += k60;
      if (pt.fade) pt.fo = (pt.fo == null ? 1 : pt.fo) - .03 * k60;
      if (pt.life > pt.max || pt.fo <= 0 || pt.y > h + 60 || pt.y < -80 || pt.x < -80 || pt.x > w + 80) { parts.splice(m, 1); continue; }
      var lifeA = Math.min(1, pt.life / 30) * Math.min(1, (pt.max - pt.life) / 40) * (pt.fo == null ? 1 : pt.fo);
      if (pt.kind === 'spark') {
        pt.vx *= Math.pow(.94, k60); pt.vy = pt.vy * Math.pow(.94, k60) + .12 * k60;
        pt.x += pt.vx * k60; pt.y += pt.vy * k60;
        ctx.globalCompositeOperation = 'lighter';
        ctx.strokeStyle = pt.white ? 'rgba(255,255,255,' + lifeA.toFixed(3) + ')' : 'rgba(' + rgb + ',' + lifeA.toFixed(3) + ')';
        ctx.lineWidth = pt.size; ctx.lineCap = 'round';
        ctx.beginPath(); ctx.moveTo(pt.x, pt.y); ctx.lineTo(pt.x - pt.vx * 2.4, pt.y - pt.vy * 2.4); ctx.stroke();
        ctx.globalCompositeOperation = 'source-over';
        continue;
      }
      pt.rot += pt.vr * k60;
      if (pt.kind === 'petals') {
        pt.x += (pt.vx + Math.sin(pt.life / 40 + pt.ph) * .6) * k60; pt.y += pt.vy * k60;
        var flip = Math.cos(pt.life / 22 + pt.ph);
        ctx.save(); ctx.translate(pt.x, pt.y); ctx.rotate(pt.rot); ctx.scale(1, Math.abs(flip) * .8 + .2);
        ctx.fillStyle = 'rgba(255,' + (170 + Math.round(flip * 20)) + ',214,' + (lifeA * .85).toFixed(3) + ')';
        ctx.beginPath(); ctx.ellipse(0, 0, pt.size, pt.size * .55, 0, 0, TAU); ctx.fill();
        ctx.restore();
      } else if (pt.kind === 'embers') {
        pt.x += (pt.vx + Math.sin(pt.life / 18 + pt.ph) * .35) * k60; pt.y += pt.vy * k60;
        var fl = .55 + .45 * Math.sin(pt.life / 4 + pt.ph);
        ctx.globalCompositeOperation = 'lighter';
        var g = ctx.createRadialGradient(pt.x, pt.y, 0, pt.x, pt.y, pt.size * 4);
        g.addColorStop(0, 'rgba(255,220,160,' + (lifeA * fl).toFixed(3) + ')');
        g.addColorStop(.35, 'rgba(' + rgb + ',' + (lifeA * fl * .6).toFixed(3) + ')');
        g.addColorStop(1, 'rgba(' + rgb + ',0)');
        ctx.fillStyle = g; ctx.beginPath(); ctx.arc(pt.x, pt.y, pt.size * 4, 0, TAU); ctx.fill();
        ctx.globalCompositeOperation = 'source-over';
      } else if (pt.kind === 'dust' || pt.kind === 'snow') {
        pt.x += (pt.vx + Math.sin(pt.life / 60 + pt.ph) * .2) * k60; pt.y += pt.vy * k60;
        var tw = .5 + .5 * Math.sin(pt.life / 14 + pt.ph);
        ctx.fillStyle = pt.kind === 'snow' ? 'rgba(235,242,255,' + (lifeA * (.4 + tw * .5)).toFixed(3) + ')' : 'rgba(' + rgb + ',' + (lifeA * (.35 + tw * .65)).toFixed(3) + ')';
        ctx.beginPath(); ctx.arc(pt.x, pt.y, pt.size, 0, TAU); ctx.fill();
      } else {
        pt.x += pt.vx * k60; pt.y += pt.vy * k60;
        ctx.save(); ctx.translate(pt.x, pt.y); ctx.rotate(pt.rot);
        ctx.strokeStyle = 'rgba(' + rgb + ',' + (lifeA * .7).toFixed(3) + ')'; ctx.lineWidth = 1;
        ctx.beginPath(); ctx.moveTo(0, -pt.size); ctx.lineTo(pt.size * .87, pt.size * .5); ctx.lineTo(-pt.size * .87, pt.size * .5); ctx.closePath(); ctx.stroke();
        ctx.restore();
      }
    }

    // lightning (Mythic)
    if (this.fx === 'bolts' && now > this.nextBolt) {
      var s = this.stage.getBoundingClientRect(), rr = el.getBoundingClientRect();
      this.bolt(s.left - rr.left + s.width / 2 + rnd(-40, 40), s.top - rr.top + s.height * rnd(.2, .5));
      this.nextBolt = now + rnd(3800, 7000);
    }
    for (var b = this.bolts.length - 1; b >= 0; b--) {
      var bo = this.bolts[b], ba = (now - bo.t) / 420;
      if (ba >= 1) { this.bolts.splice(b, 1); continue; }
      var al = (1 - ba) * (ba < .12 ? 1 : .55 + .45 * Math.sin(ba * 60));
      ctx.globalCompositeOperation = 'lighter';
      ctx.fillStyle = 'rgba(' + rgb + ',' + (al * .05).toFixed(3) + ')'; ctx.fillRect(0, 0, w, h);
      ctx.lineJoin = 'round';
      [[7, .12], [3, .35], [1.2, .95]].forEach(function (st) {
        ctx.strokeStyle = st[1] > .9 ? 'rgba(255,250,230,' + (al * st[1]).toFixed(3) + ')' : 'rgba(' + rgb + ',' + (al * st[1]).toFixed(3) + ')';
        ctx.lineWidth = st[0]; ctx.beginPath();
        bo.pts.forEach(function (pp, z) { z ? ctx.lineTo(pp[0], pp[1]) : ctx.moveTo(pp[0], pp[1]); });
        ctx.stroke();
      });
      ctx.globalCompositeOperation = 'source-over';
    }
  };

  function boot(root) {
    [].slice.call((root || document).querySelectorAll('[data-prophecy-hero]')).forEach(function (el) { new Hero(el); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  // Shopify theme editor support
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target.closest && e.target.closest('[data-prophecy-hero]');
    if (el && el.__ph) { var k = el.__ph.bats.indexOf(e.target); if (k > -1) { el.__ph.autoplay = false; el.classList.remove('is-autoplay'); el.__ph.go(k); } }
  });
})();
